import React, { useRef } from 'react';

import { faPlus } from '@fortawesome/pro-regular-svg-icons';

import { Button } from 'components/ui/button';

interface Props {
  disabled: boolean;
  onAddAttachments: (attachments: File[]) => void;
}

export function AttachmentsInput({ disabled, onAddAttachments }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const files = Array.from(e.target.files || []);
    if (files.length) {
      onAddAttachments(files);
    }

    // Reset so picking the same file again still fires onChange.
    e.target.value = '';
  }

  return <>
    <Button
      aria-label="Attach files"
      disabled={disabled}
      icon={faPlus}
      variant="ghost"
      onClick={() => inputRef.current?.click()}
    />

    <input
      className="d-none"
      multiple
      ref={inputRef}
      type="file"
      onChange={handleChange}
    />
  </>;
}
